import { TableColumnMeta } from "ds/components/Table/types";

export enum INTENT_PROJECTS_COLUMN_ID {
  NAME = "NAME",
  DESCRIPTION = "DESCRIPTION",
  SPACE = "SPACE",
  CREATED_AT = "CREATED_AT",
  LAST_RESOURCES_UPDATED_AT = "LAST_RESOURCES_UPDATED_AT",
  CREATED_BY = "CREATED_BY",
  LOCKED = "LOCKED",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 2000;

export const INTENT_PROJECTS_COLUMNS_STORAGE_KEY = "intentProjectsColumnsConfig";
export const INTENT_PROJECTS_SORT_STORAGE_KEY = "intentProjectsSortConfig";
export const INTENT_PROJECTS_LIMIT_STORAGE_KEY = "intentProjectsLimit";
export const INTENT_PROJECTS_PAGINATION_OPTIONS = [10, 25, 50];

export const INTENT_PROJECTS_COLUMN_CONFIG: Record<INTENT_PROJECTS_COLUMN_ID, TableColumnMeta> = {
  [INTENT_PROJECTS_COLUMN_ID.NAME]: {
    id: INTENT_PROJECTS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 300,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECTS_COLUMN_ID.LOCKED]: {
    id: INTENT_PROJECTS_COLUMN_ID.LOCKED,
    title: "Locked",
    minWidth: 140,
    defaultWidth: 140,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECTS_COLUMN_ID.DESCRIPTION]: {
    id: INTENT_PROJECTS_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 130,
    defaultWidth: 240,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECTS_COLUMN_ID.SPACE]: {
    id: INTENT_PROJECTS_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 140,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECTS_COLUMN_ID.CREATED_AT]: {
    id: INTENT_PROJECTS_COLUMN_ID.CREATED_AT,
    title: "Created at",
    minWidth: 170,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECTS_COLUMN_ID.LAST_RESOURCES_UPDATED_AT]: {
    id: INTENT_PROJECTS_COLUMN_ID.LAST_RESOURCES_UPDATED_AT,
    title: "Last resources updated at",
    minWidth: 220,
    defaultWidth: 240,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECTS_COLUMN_ID.CREATED_BY]: {
    id: INTENT_PROJECTS_COLUMN_ID.CREATED_BY,
    title: "Created by",
    minWidth: 160,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [INTENT_PROJECTS_COLUMN_ID.DROPDOWN]: {
    id: INTENT_PROJECTS_COLUMN_ID.DROPDOWN,
    title: "Intent Project actions",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};

export const INTENT_PROJECTS_SORT_CONFIG: Record<string, string> = {
  [INTENT_PROJECTS_COLUMN_ID.NAME]: "name",
  [INTENT_PROJECTS_COLUMN_ID.LOCKED]: "is_locked",
  [INTENT_PROJECTS_COLUMN_ID.SPACE]: "space",
  [INTENT_PROJECTS_COLUMN_ID.CREATED_AT]: "createdAt",
};
